module.exports = __webpack_public_path__ + "static/Unilever-DSEP-ClassroomActivity-Virtual-2.4-BullyinginourSchool_FR-7a7e2db9f2144de3ea0e623a7c69ccbb.pdf";